import { SET_USER_PLANS } from '../actions/plans';

const initialState = {
    userPlans: null,
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_USER_PLANS:
            return {
                ...state,
                userPlans: action.payload,
            };
            default:
                return state;
        }
    }
    
export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/plans.js